diy.angular.registerFactory('diyfmsubsectionmodel', [
    '$q', 
    'diyl10n', 
    '$timeout', 
    'diyfmitemmodel', 
    'diyfmselectiondata',
function(
    $q, 
    diyl10n, 
    $timeout, 
    diyfmitemmodel, 
    diyfmselectiondata
){
    
    var diyfmsubsectionmodel = function(id, title, source, typeName, defaultParams) {
        this._id = id;
        this._title = title;
        this._source = source;
        
        this._typeName = typeName;
        this._defaultParams = defaultParams || {};
        
        this._section = undefined;
        this._items = undefined;
        this._search = '';
        this._colorSearch = null;
        this._allItemsLoaded = false;
        
        this._loadingDefer = $q.defer();
    };
    
    angular.extend(diyfmsubsectionmodel.prototype, {
        _actions: [],
        _itemActions: [],

        isNew: function() {
            return false;
        },
        
        getSection: function() {
            return this._section;
        },
        
        getSource: function() {
            return this._source;
        },
        
        getItemsProvider: function() {
            return this.getSource().getItemsProvider();
        },

        getId: function() {
            return this._id;
        },

        getTitle: function() {
            return this._title;
        },

        getTypeName: function() {
            return this._typeName;
        },

        getItems: function() {
            return this._items;
        },
        
        setTitle: function(newTitle) {
            this._title = newTitle;
        },

        setSource: function(newSource) {
            this._source = newSource;
        },
        
        clearItemsCache: function() {
            this._items = undefined;
            this._allItemsLoaded = false;
            this._loadingDefer.reject();
            this._loadingDefer = $q.defer();
        },
        
        getDefaultParams: function() {
            return this._defaultParams;
        },
        
        loadItems: function(offset, limit) {
            var defer = $q.defer();
            
            this.getItemsProvider()
                .queryRange(angular.extend(this.getDefaultParams(), {
                    search: this.getSearch(),//TODO: refactor this to support multiple search vectors
                    colorSearch: this.getColorSearch()
                }), offset, limit)
                .then(function(data) {
                    defer.resolve(data);
                });
            
            return defer.promise;
        },
        
        _instanciateItem: function(resource) {
            return new diyfmitemmodel(resource, this.getSource());
        },
        
        getOrLoadAllItems: function() {
            var defer = $q.defer(), self = this;
            
            if (this._allItemsLoaded) {
                defer.resolve(this._items);
            } else {
                // do a loading of missing range
                var 
                    firstUndef, 
                    lastUndef,
                    offset,
                    limit,
                    i
                ;
                if (this._items !== undefined) {
                    for(i = 0; i < this._items.length; i++) {
                        if (this._items[i] === undefined) {
                            firstUndef = i;
                            break;
                        }
                    }
                    for(i = this._items.length - 1; i >= 0; i--) {
                        if (this._items[i] === undefined) {
                            lastUndef = i;
                            break;
                        }
                    }
                    if (firstUndef !== undefined) {
                        offset = firstUndef;
                        limit = lastUndef - firstUndef + 1;
                    } else {
                        // let offset to be undefined to not perform any loading
                        // it seems that we are inprogress with loading
                    }
                } else {
                    // nothing loaded, we need all
                    offset = 0;
                }
                if (offset !== undefined) {
                    this.retrieveItems(offset, limit);
                }
                this._loadingDefer.promise.then(function(){
                    defer.resolve(self._items);
                }, function(){
                    defer.reject();
                });
            }

            return defer.promise;
        },
        
        retrieveItems: function(offset, limit) {
            if (this._search == '' && this._itemsBeforeSearch) {
                this._items = this._itemsBeforeSearch._items;
                this._allItemsLoaded = this._itemsBeforeSearch._allItemsLoaded;
                this._itemsBeforeSearch = null;
            }
            var 
                self = this,
                defer = $q.defer(),
                ret = [],
                shouldLoad = false,
                loadOffset = offset,
                initialLoad = false,
                items = this._items
            ;
            if (items === undefined) {
                shouldLoad = true;
                initialLoad = true;
            } else if (items.length === 0) {
                defer.resolve(ret);
            } else {
                var 
                    from = Math.min(offset, items.length - 1),
                    to = Math.min(items.length - 1, offset + limit - 1),
                    firstUndef,
                    lastUndef
                ;
                for (var i = from; i <= to; i++) {
                    if (items[i] === undefined) {
                        if (firstUndef === undefined) {
                            firstUndef = i;
                        }
                        lastUndef = i;
                        // create items with an empty resource
                        // it will be set later after data loaded from server                        
                        items[i] = this._instanciateItem({});
                    }
                    ret.push(items[i]);
                }
                // let's do a quick promise resolve, even if maybe not all returned items
                // have loaded resources
                defer.resolve(ret);
                
                if (firstUndef !== undefined) {
                    shouldLoad = true;
                    if (firstUndef > from) {
                        // do "forward" loading, perhaps a use-case when 
                        // scrolling to bottom
                        loadOffset = firstUndef;
                    } else if (lastUndef < to) {
                        // do "backward" loading, perhaps a use-case when 
                        // scrolling to bottom
                        loadOffset = Math.max(0, lastUndef - limit + 1);
                    }
                    // normalize limit
                    limit = Math.min(this._items.length - loadOffset, limit);
                    // create items with an empty resource
                    // it will be set later after data loaded from server
                    var loadTo = loadOffset + limit - 1;
                    for (var j = loadOffset; j <= loadTo; j++) {
                        if (items[j] === undefined) {
                            items[j] = this._instanciateItem({});
                        }
                    }
                }
            }
            if (shouldLoad) {
                // TODO put loadPromises in an array
                // so that on user cancel we can reject them 
                this.loadItems(loadOffset, limit)
                    .then(function(data) {
                        var j, i = loadOffset, resources = data.items;
                        
                        if (initialLoad) {
                            self._items = new Array(parseInt(data.totalCount, 10));
                            for(j = 0; j < resources.length; j++, i++) {
                                ret.push(self._items[i] = self._instanciateItem(resources[j]));
                            };
                            defer.resolve(ret);
                        } else {
                            for(j = 0; j < resources.length; j++, i++) {
                                self._items[i].setResource(resources[j]);
                            };
                        }
                        self._loadingDefer.notify();
                        var hasUndefined = false, k;
                        for (k = self._items.length - 1; k >= 0; k --) {
                            if (self._items[k] === undefined) {
                                hasUndefined = true;
                                break;
                            }
                        }
                        if (!hasUndefined) {
                            self._allItemsLoaded = true;
                            self._loadingDefer.resolve();
                        }
                    });
            }
            return defer.promise;
        },

        getActions: function() {
            return this._actions;
        },

        getItemActions: function() {
            return this._itemActions;
        },

        canMoveTo: function() {
            return false;
        },
        
        getSearch: function() {
            return this._search;
        },
        
        setSearch: function(newSearch) {
            if (newSearch !== this._search) {
                if (this._search == '' && this._colorSearch === null) {
                    this._itemsBeforeSearch = {
                        _items: this._items,
                        _allItemsLoaded: this._allItemsLoaded
                    };
                }
                this._search = newSearch;
                this.clearItemsCache();
                diyfmselectiondata.removeAllItems(['select']);
            }
        },

        getColorSearch: function() {
            return this._colorSearch;
        },

        setColorSearch: function(newSearch) {
            if (newSearch !== this._colorSearch) {
                this._itemsBeforeSearch = null;
                this._colorSearch = newSearch;
                this.clearItemsCache();
                diyfmselectiondata.removeAllItems(['select']);
            }
        },

        resetSearch: function() {
            this.setSearch('');
        },
        
        setId: function(newId) {
            if (this._id.id) {
                throw new Error('Ids cannot be changed. Only initially set');
            }
            this._id = newId;
        },
        
        getItemIndex: function(item) {
            return this._items && this._items.indexOf(item);
        }
    });
    return diyfmsubsectionmodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmsubsectionmodel.js
 ** module id = 954
 ** module chunks = 0
 **/